module.exports = __webpack_public_path__ + "img/SA-Overview-Icon-removebg-preview (2).6ff58d66.png";